import React from 'react';

export const ActionButton = ({ 
  children, 
  variant = 'primary', // 'primary' | 'secondary' | 'error' | 'success' | 'warning' | 'info'
  onClick, 
  className = '', 
  ...props 
}) => {
  const baseClasses = 'px-2.5 py-1.5 rounded-md text-xs transition-colors focus:outline-none focus:ring-2';

  const variantClasses = {
    tableActionbutton: 'inline-flex items-center px-2.5 py-1 rounded-md text-xs font-semibold bg-primary-600 text-white hover:bg-primary-700',
    primary: 'bg-primary-50 text-primary-600 border border-primary-300 hover:bg-primary-100 hover:text-primary-700 hover:border-primary-400 focus:ring-primary-300',
    secondary: 'bg-secondary-50 text-secondary-600 border border-secondary-300 hover:bg-secondary-100 hover:text-secondary-700 hover:border-secondary-400 focus:ring-secondary-300',
    error: 'bg-error-50 text-error-600 border border-error-300 hover:bg-error-100 hover:text-error-700 hover:border-error-400 focus:ring-error-300',
    success: 'bg-success-50 text-success-700 border border-success-300 hover:bg-success-100 hover:text-success-800 hover:border-success-400 focus:ring-success-400',
    warning: 'bg-warning-50 text-warning-600 border border-warning-300 hover:bg-warning-100 hover:text-warning-700 hover:border-warning-400 focus:ring-warning-300',
    info: 'bg-info-50 text-info-600 border border-info-300 hover:bg-info-100 hover:text-info-700 hover:border-info-400 focus:ring-info-300'
  };

  return (
    <button
      onClick={onClick}
      className={`${baseClasses} ${variantClasses[variant]} ${className}`}
      {...props}
    >
      {children}
    </button>
  );
};
